export default {
    title: '云储能大数据综合服务平台'
}



// WEBPACK FOOTER //
// ./src/config/i18n/zh-cn/header.js